import { useEffect, useState } from 'react'

import { DATE_CONSTANTS } from '@/domain/constants/date'

interface CountdownOptions {
  initialSeconds: number
  onComplete?: () => void
}

export const useCountdown = ({
  initialSeconds,
  onComplete,
}: CountdownOptions) => {
  const [seconds, setSeconds] = useState(initialSeconds)
  const [isActive, setIsActive] = useState(true)

  useEffect(() => {
    if (!isActive) return

    if (seconds <= 0) {
      onComplete?.()
      setIsActive(false)
      return
    }

    const timerId = setInterval(() => {
      setSeconds((prev) => prev - 1)
    }, DATE_CONSTANTS.TIME_IN_MILLISECONDS.SECOND * 1)

    return () => clearInterval(timerId)
  }, [seconds, isActive, onComplete])

  const reset = (newSeconds?: number) => {
    setSeconds(newSeconds || initialSeconds)
    setIsActive(true)
  }

  const pause = () => {
    setIsActive(false)
  }

  const resume = (newSeconds?: number) => {
    setSeconds(newSeconds || initialSeconds)
    setIsActive(true)
  }

  return {
    seconds,
    isActive,
    reset,
    pause,
    resume,
  }
}
